'use client'

import { usePathname } from 'next/navigation'

import LocalizedClientLink from '@modules/common/components/localized-client-link'
import { ArrowRightIcon } from '@modules/common/icons'

function createBreadcrumbs(fullpath) {
  let fullLink = '/'
  let paths = fullpath
    .split('/')
    .filter((p, i) => i > 1)
    .map((p) => {
      fullLink += p + '/'

      const pa = {
        label: p
          .replace(/-prod.*/, '')
          .replaceAll('-', ' ')
          .replace('experience', 'experiences')
          .replace('bubble', 'Bulles Vertes'),
        link: `${fullLink.replace('experience', 'search')}`,
      }

      return pa
    })

  return [{ label: 'Accueil', link: '/' }, ...paths]
}

export default function Breadcrumbs({}) {
  const pathname = usePathname()
  const breadcrumbs = createBreadcrumbs(pathname)
  breadcrumbs.pop()

  return (
    <>
      <ul className="flex w-fit flex-row items-center justify-start gap-4">
        {breadcrumbs &&
          breadcrumbs.map((b, i) => (
            <div className="flex flex-row items-center gap-4" key={b.link}>
              <li className="capitalize">
                <LocalizedClientLink href={b.link}>
                  {b.label}
                </LocalizedClientLink>
              </li>
              {i < 1 && <ArrowRightIcon color="#fff" />}
            </div>
          ))}
      </ul>
    </>
  )
}
